import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/AuthContext";
import { LogOut, Map, Bookmark } from "lucide-react";
import BremaLogo from "@/components/BremaLogo";
import LangToggle from "@/components/LangToggle";
import { useI18n } from "@/lib/i18n";

export default function Navbar() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const { t } = useI18n();

  const onLogout = async () => {
    await logout();
    nav("/", { replace: true });
  };

  const linkCls = (path) =>
    `font-display uppercase tracking-wider text-sm px-3 py-2 border-b-2 transition-colors ${
      loc.pathname === path
        ? "border-brema-yellow text-brema-yellow"
        : "border-transparent text-zinc-100 hover:text-white"
    }`;

  return (
    <header className="sticky top-0 z-40 border-b border-white/10 bg-brema-obsidian/80 backdrop-blur-xl">
      <div className="max-w-7xl mx-auto flex items-center justify-between px-6 py-4">
        <Link
          to="/dashboard"
          data-testid="nav-logo"
          className="flex items-center gap-3"
        >
          <BremaLogo height={44} />
          <div className="leading-none border-l border-white/15 pl-3">
            <div className="font-display font-black text-white text-sm uppercase tracking-[0.2em]">
              ValliRider
            </div>
          </div>
        </Link>

        <nav className="hidden md:flex items-center gap-1">
          <Link to="/dashboard" data-testid="nav-configure" className={linkCls("/dashboard")}>
            <span className="inline-flex items-center gap-2">
              <Map size={14} /> {t("configure")}
            </span>
          </Link>
          <Link to="/rides" data-testid="nav-rides" className={linkCls("/rides")}>
            <span className="inline-flex items-center gap-2">
              <Bookmark size={14} /> {t("rides")}
            </span>
          </Link>
        </nav>

        <div className="flex items-center gap-3">
          <LangToggle />
          {user?.picture ? (
            <img
              src={user.picture}
              alt={user.name}
              className="w-8 h-8 border border-white/20 grayscale hover:grayscale-0 transition"
            />
          ) : (
            <div className="w-8 h-8 border border-white/20 bg-zinc-900 flex items-center justify-center text-xs font-mono text-brema-yellow">
              {user?.name?.[0] || "R"}
            </div>
          )}
          <button
            onClick={onLogout}
            data-testid="nav-logout-btn"
            className="text-zinc-100 hover:text-brema-red transition p-2"
            title="Logout"
          >
            <LogOut size={16} />
          </button>
        </div>
      </div>
    </header>
  );
}
